// some of these changes may need to be made in /public/settings.js as well 

export let SP_API_URL = 'http://localhost:8011';
export let WIDGET_URL = 'http://localhost:3000';

SP_API_URL = 'https://api.smarterproctoring.com';

export let POST_HOG_KEY = 'phc_';
export let POST_HOG_HOST  = 'https://app.posthog.com';

if (process.env.REACT_APP_ENV === 'development') {
  SP_API_URL = 'https://api.dev.smarterproctoring.com';
  WIDGET_URL = 'https://help.dev.smarterservices.com';
}

if (process.env.REACT_APP_ENV === 'production') {
  SP_API_URL = 'https://api.smarterproctoring.com';
  POST_HOG_KEY = 'phc_';
  WIDGET_URL = 'https://help.smarterservices.com';
}

export const API_ROUTES = {
  GET_USER: `${SP_API_URL}/v1/me`,
  CHECK_AUTHENTICATION: `${SP_API_URL}/v1/check`
  
}

export const APP_ROUTES = {
  SESSION: '/session/:sessionSid',
  UNAUTHORIZED: '/unauthorized'
} 